import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getSubscriptionStatus } from '../../services/paymentService';
import './PaymentSuccess.css';

function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const { isAuthenticated } = useAuth();
  const [quota, setQuota] = useState(null);
  const [loading, setLoading] = useState(true);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    const loadStatus = async () => {
      if (!isAuthenticated) {
        setLoading(false);
        return;
      }
      try {
        const data = await getSubscriptionStatus();
        setQuota(data.quota);
      } catch (err) {
        console.error('Erreur chargement statut:', err);
      } finally {
        setLoading(false);
      }
    };

    const timer = setTimeout(loadStatus, 1500);
    return () => clearTimeout(timer);
  }, [isAuthenticated, sessionId]);

  return (
    <div className="payment-success">
      <div className="success-card">
        <div className="success-icon">&#10003;</div>
        <h1>Paiement réussi !</h1>
        <p className="success-message">
          Vos crédits de génération ont été ajoutés à votre compte.
        </p>

        {!loading && quota && (
          <div className="success-quota">
            <span className="quota-label">Crédits disponibles</span>
            <span className="quota-value">
              {quota.remaining === null ? 'Illimité' : quota.remaining}
            </span>
          </div>
        )}

        <div className="success-actions">
          <Link to="/" className="success-btn success-btn-primary">
            Générer un cours
          </Link>
          <Link to="/pricing" className="success-btn success-btn-secondary">
            Voir les offres
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
